const messages = {
  threads: {
    orders: { title: "", content: "" },
    externalTraining: { title: "", content: "" },
    InvestmentSupport: { title: "", content: "" },
    onlineTraining: { title: "", content: "" },
    bTraining: { title: "", content: "" },
    hunter: { title: "", content: "" },
    profileComplete: { title: "", content: "" },
    activeUser: { title: "", content: "" },
    deleteItemFromOrder: { title: "", content: "" },
    deleteOrder: { title: "", content: "" },
    commitmentLetter: {
      title: "Dziękujemy za rejestrację",
      content:
        "Witaj,<br/>Dziękujemy za rejestrację. Z przyjemnością informujemy, że Twoja rejestracja w BRIDGESTONE PLUS została zatwierdzona.<br/>Mamy nadzieję, że BRIDGESTONE PLUS przyniesie Ci sukces i cenne możliwości, a także liczymy na dalszą współpracę.<br/>Z pozdrowieniami<br/>Zespół BRIDGESTONE PLUS",
    },
    uberall: { title: "", content: "" },
    welcome: {
      title: "Dziękujemy za rejestrację",
      content:
        "Witaj,<br/>Dziękujemy za rejestrację. Z przyjemnością informujemy, że Twoja rejestracja w BRIDGESTONE PLUS została zatwierdzona.<br/>Mamy nadzieję, że BRIDGESTONE PLUS przyniesie Ci sukces i cenne możliwości, a także liczymy na dalszą współpracę.<br/>Z pozdrowieniami<br/>Zespół BRIDGESTONE PLUS",
    },
    booster: { title: "", content: "" },
    orderStatus_RETURNED: { title: "", content: "" },
    orderStatus_REJECTED: { title: "", content: "" },
    kickbackPayback: { title: "", content: "" },
    survey_thankyou: { title: "", content: "" },
    survey: { title: "", content: "" },
    salesPromotions: { title: "", content: "" },
  },
};

export default {
  messages,
};
